/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ScheduledVbrTaskType {
    Patch,
    Upgrade,
    Deploy,
}
